import { toRefs } from "@vueuse/core";
import { computed } from "vue";
import {} from "@/stores/workflowStepStore";
export function useStepProps(step) {
    const { id: stepId, content_id: contentId, name, type, inputs: stepInputs, outputs: stepOutputs, post_job_actions: postJobActions, } = toRefs(step);
    const label = computed(() => { var _a; return (_a = step.value.label) !== null && _a !== void 0 ? _a : undefined; });
    const annotation = computed(() => { var _a; return (_a = step.value.annotation) !== null && _a !== void 0 ? _a : null; });
    const configForm = computed(() => step.value.config_form);
    return {
        stepId,
        contentId,
        annotation,
        label,
        name,
        type,
        stepInputs,
        stepOutputs,
        configForm,
        postJobActions,
    };
}
